export const colors = {
    primary: '#3D73DD',
    secondary: '#FFD841',
    system_blue: '#C9DBFF',
    system_blue40: '#C9DBFF66',
    system_blue70: '#3D73DDB2',
    deep_blue: '#153861',
    deep_blue50: '#5E7093',
    white: '#FFFFFF',
    black: '#000000',
    red: '#FF553E',

    Text_1: '#3D4244',
    Text_2: '#787878',
    Text_3: '#1C3669',
    trans: '#00ff0000',
    Secondiary: '#FFD841',
    schdule: '#A8C0F0',
    off: 'rgba(124,124,124,0.4)',
    oneTime: '#6A6F7C',

    // 승연님 디자인 시스템 컬러
    PRIMARY_BLUE: '#3D73DD',
    ERROR: '#FF3E4A',
    ERROR_50: '#FFE8E9',
    ERROR_200: '#FF9BA1',
    SUCCESS: '#00A793',
    SUCCESS_50: '#E5F8F3',
    WARNING: '#B45309',
    WARNING_50: '#FEF3C7',
    CHANGE: '#FF8777',
    CHANGEYELLOW: '#FFF8E0',
    PINK: '#FD8FE5',
    PURPLE: '#9E76F3',
    GREEN: '#00A793',
    ORANGE: '#FF8777',
    YELLOW: '#FFD977',
    CYAN: '#17B5CB',

    POINT_1: '#3D73DD',
    POINT_2: '#1A305D',
    LAVEL_0: '#FDFEFF',
    LAVEL_1: '#6E6E6E',
    LAVEL_2: '#4A4A4A',
    LAVEL_3: '#353535',
    LAVEL_4: '#000000',

    BLUE_50: '#ECF1FC',
    BLUE_100: '#C3D4F4',
    BLUE_200: '#A6BFEF',
    BLUE_300: '#7DA1E8',
    BLUE_400: '#648FE4',
    BLUE_500: '#3D73DD',
    BLUE_600: '#3869C9',
    BLUE_700: '#2B529D',
    BLUE_800: '#223F7A',
    BLUE_900: '#1A305D',

    WHITE_50: '#FDFEFF',
    WHITE_100: '#F8FBFF',
    WHITE_200: '#F5F9FF',
    WHITE_300: '#F0F6FF',
    WHITE_400: '#EDF4FF',
    WHITE_500: '#E9F1FF',
    WHITE_600: '#D4DBE8',
    WHITE_700: '#A5ABB5',
    WHITE_800: '#80858C',
    WHITE_900: '#62656B',

    Gray: '#F4F5F7',
    GREY_50: '#EDEDED',
    GREY_100: '#C7C7C7',
    GREY_200: '#ACACAC',
    GREY_300: '#868686',
    GREY_400: '#6E6E6E',
    GREY_500: '#4A4A4A',
    GREY_600: '#434343',
    GREY_700: '#353535',
    GREY_800: '#292929',
    GREY_900: '#1F1F1F',

    GREEN_50: '#51C070',
    GREY: '#F2F4F6',
};

export const WHITE = '#ffffff';

/**
 * Semantic design tokens
 * ----------------------
 * Phase 1 of UX unification (2026-04).
 * Ad-hoc badge colors scattered across pages should be replaced with these.
 *
 * - success : 활성/정상 상태 (ACTIVE 수강권, 출석 완료 등)
 * - warning : 주의 상태 (만료 임박, 부분 환불, 미수금 등)
 * - danger  : 실패/환불/만료 상태 (EXPIRED, REFUNDED 등)
 * - neutral : 분류 레이블 (회원 타입, 수강권 명 등 — 상태가 아닌 것)
 * - info    : 정보성 강조 (담당 강사, PT/그룹 구분 등)
 */
export type SemanticTone = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

export const semanticColors: Record<
    SemanticTone,
    { bg: string; text: string; border: string }
> = {
    success: { bg: '#E5F8F3', text: '#00A793', border: '#B3E8DE' }, // SUCCESS
    warning: { bg: '#FEF3C7', text: '#B45309', border: '#FDE68A' }, // WARNING
    danger: { bg: '#FFE8E9', text: '#FF3E4A', border: '#FFC1C5' }, // ERROR
    neutral: { bg: '#F2F4F6', text: '#4A4A4A', border: '#E5E7EB' }, // GREY / GREY_500
    info: { bg: '#ECF1FC', text: '#3D73DD', border: '#C3D4F4' }, // BLUE_50 / PRIMARY_BLUE
};

/**
 * Layout tokens — page shell consistency.
 * Used by PageHeader + page containers to eliminate per-page margin/padding drift.
 */
export const layout = {
    page: {
        maxWidth: 1192, // 기존 MemberMembershipManagePage 기준
        paddingX: 64, // px-64 (기존)
        paddingTop: 32, // pt-32 (기존)
        paddingBottom: 64, // pb-16 (기존)
        marginTop: 64, // 공용 헤더 아래 기본 여백
        bg: '#F4F5F7', // Gray — 기존 페이지 배경
    },
    card: {
        radius: 12,
        border: '#E5E7EB',
        shadow: '0 1px 3px rgba(0, 0, 0, 0.04)',
    },
} as const;
